import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Typography,
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  Input,
} from '@material-ui/core'
import { updateEntity, updateMessageSamples } from './redux'
import { create } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import { v4 as uuidv4 } from 'uuid'
import { toggleDialog } from 'actions/view'
import { bindActionCreators } from 'redux'
// import { Link } from 'react-router-dom'

const CampaignStep = ({
  entityKey, // Assuming this prop is passed to identify the specific campaign/draft
  updateEntity,
  updateMessageSamples,
  entityType,
  entity,
  handleBack,
  alreadyCreatedApplication,
  directive,
  create,
  idTokenPayload,
  sms_double_opt_disclaimer,
  a2p10dlcID,
  toggleDialog,
}) => {
  const handleChange = event => {
    const { name, value } = event.target
    // Update the entire entity; might need to be adjusted based on your state structure
    updateEntity(entityType, entityKey, { ...(entity || {}), [name]: value })
  }

  const handleAddMessageSample = () => {
    // Add a new message sample
    updateMessageSamples(entityType, entityKey, -1, '')
  }

  const handleRemoveMessageSample = index => {
    // Remove a message sample
    updateMessageSamples(entityType, entityKey, index)
  }

  const handleUpdateMessageSample = (index, value) => {
    // Update a specific message sample
    updateMessageSamples(entityType, entityKey, index, value)
  }

  const disabled =
    Boolean(alreadyCreatedApplication) &&
    directive !== 'additionalHighVolumeUseCase' &&
    directive !== 'upgradeToHighVolume'

  const isSubmitEnabled = () => {
    const hasDescription = entity?.description?.trim().length > 0
    const hasMessageFlow = entity?.messageFlow?.trim().length > 0
    const validMessageSamples =
      entity?.messageSamples?.filter(sample => sample.trim().length > 0)
        .length >= 2
    return hasDescription && hasMessageFlow && validMessageSamples
  }

  const handleSubmit = () => {
    const requestUUID = uuidv4()

    create({
      entityType: 'a2p10dlc',
      entity: {
        requestUUID,
        requests: {
          [requestUUID]: {
            requestUUID,
            ...entity,
            messageFlow:
              entity?.messageFlow +
              '\n\n' +
              'Leads will then receive the following messages for double opt-in: ' +
              `"${sms_double_opt_disclaimer}"` +
              '\n' +
              '"Reply CONFIRM to receive messages from us.  We respect your privacy and you can reply STOP to opt-out at any time. We will occasionally send you news and updates for our events and products. Message and data rates apply."',
            useCase: entityKey,
            directive,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            status: 'pending',
            user_phone_number: idTokenPayload?.phone_number,
            user_email: idTokenPayload?.email,
          },
        },
        directive,
        id: a2p10dlcID,
      },
      noReturnValue: true,
      url: `${DATA_API_URL}/a2p10dlc`,
      hasSchema: false,
      snackbarMessage: 'Successfully submitted use case application!',
    }).then(() => {
      toggleDialog({ dialog: 'A2P10DLC', open: false })
    })
  }

  return (
    <>
      {/* <Button onClick={handleBack}>Back</Button> */}
      <TextField
        disabled={disabled}
        label="Why are you sending text messages?"
        multiline
        rowsMax="4"
        name="description"
        value={entity?.description || ''}
        onChange={handleChange}
        helperText={
          'Provide an explanation of who the sender is, who the recipient is, ' +
          'and why messages are being sent to the intended recipient. ' +
          'Example: "We will send weekly marketing messages about sales ' +
          'and offers from Acme Sandwich Company to end customers who have opted in"'
        }
        fullWidth
        margin="normal"
        placeholder="Enter text here"
        InputLabelProps={{
          shrink: true,
          style: { fontSize: 22, fontWeight: 'bold' },
        }}
        FormHelperTextProps={{ style: { fontStyle: 'italic' } }}
        InputProps={{ style: { marginTop: 23 } }}
      />
      <div style={{ height: 28 }} />
      <FormControl fullWidth>
        <InputLabel
          style={{ fontSize: 22, fontWeight: 'bold' }}
          shrink
          htmlFor="how-do-you-get-your-leads"
        >
          How do you get your leads?
        </InputLabel>
        <Input
          disabled={disabled}
          name="messageFlow"
          value={entity?.messageFlow || ''}
          onChange={handleChange}
          placeholder="Enter text here"
          style={{ marginTop: 23 }}
        />
        <FormHelperText style={{ fontStyle: 'italic ' }}>
          Include details around all of the ways that your leads opt-in, giving
          consent to receive messages from you. If this is done via a website,
          please provide a link. If you're using one of our custom forms to get
          leads, provide a direct link to the form.
        </FormHelperText>
      </FormControl>
      <div style={{ height: 20 }} />
      {/* "sms_double_opt_disclaimer": "Hi there! Thank you for reaching out to Vast
      Reach Account manager . Before we assist you further:" */}
      {/* Reply CONFIRM to receive messages from us. We respect your privacy and you
      can reply STOP to opt-out at any time. We will occasionally send you news
      and updates for our events and products. Message and data rates apply. */}
      <br />
      <Typography style={{ fontWeight: 'bold' }} variant="h5">
        Message Samples
      </Typography>
      <FormHelperText style={{ fontStyle: 'italic' }}>
        Give between 2 and 5 examples of messages you would send. Each message
        should identify your brand by name and/or website. Also, indicate with
        brackets [] any content that is subject to change.
        <br />
        <br />
        Example: "This is a message from the Acme Sandwich Company. We saw you
        signed up to get a coupon for our [current promotion] on [date]. If you
        have questions or would like to change your order schedule, please call
        333-444-1212. If you would like to opt out of future notifications like
        this, text STOP in reply to this message."
      </FormHelperText>
      {entity?.messageSamples?.map?.((sample, index) => (
        <div key={index}>
          <TextField
            disabled={disabled}
            multiline
            rowsMax="4"
            label={`Sample ${index + 1}`}
            value={sample}
            onChange={event =>
              handleUpdateMessageSample(index, event.target.value)
            }
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
              style: { fontSize: 22, fontWeight: 'bold' },
            }}
            placeholder="Enter text here"
            InputProps={{ style: { marginTop: 23 } }}
          />
          <Button
            onClick={() => handleRemoveMessageSample(index)}
            color="secondary"
            disabled={entity?.messageSamples?.length < 3}
          >
            Remove
          </Button>
        </div>
      ))}
      <Button
        disabled={entity?.messageSamples?.length > 4 || disabled}
        onClick={handleAddMessageSample}
        color="primary"
      >
        Add Another Sample
      </Button>
      {directive === 'additionalHighVolumeUseCase' ||
      directive === 'upgradeToHighVolume' ? (
        <div style={{ textAlign: 'right', marginTop: 20 }}>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disabled={!isSubmitEnabled()}
          >
            Submit
          </Button>
        </div>
      ) : null}
    </>
  )
}

const mapStateToProps = (state, { entityType, entityKey }) => {
  return {
    entity: state.a2p10dlc.entities?.[entityType]?.[entityKey],
    alreadyCreatedApplication: Object.values(state.data?.a2p10dlc || {})
      ?.length,
    a2p10dlcID: Object.values(state.data.a2p10dlc || {})?.[0]?.id,
    idTokenPayload: state.auth?.session?.idToken?.payload,
    sms_double_opt_disclaimer:
      state.data?.['account/preference']?.preferences
        ?.sms_double_opt_disclaimer,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateEntity,
      updateMessageSamples,
      create,
      toggleDialog,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(CampaignStep)
